import styled from 'styled-components'
/**
 * Styled component is used to decorate BasketPriceContainer component.
 * Props are passed from ThemeProvider component.
 */

export const BasketRowStyle = styled.div`
  display: flex;
  align-items: center;
  img {
    height: 36px;
    padding: 0 0.25em;
  }
`
